export enum AppRoutingPathType {
  LearnerCourse,
  Learning,
  Admin,
  Tutor,
  TutorResources,
  OrganisationAndCentre,
  LearnerTransfer,
  LearnerCentreTransfer,
  AggregateReports
}